// LeafletMap.tsx
import React, { FC, ReactNode } from "react";
import styled from "styled-components";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

interface Coords {
    lat: number;
    lng: number;
}

interface LeafletMapProps {
    children?: ReactNode | ReactNode[];
    defaultZoom?: number;
    defaultCenter?: Coords;
}

const Wrapper = styled.main`
    width: 100%;
    height: 100%;
`;

const LeafletMap: FC<LeafletMapProps> = ({
                                             children = null,
                                             defaultZoom = 7,
                                             defaultCenter = { lat: -18.5779679, lng: -45.4514553 },
                                         }) => {
    return (
        <Wrapper>
            <MapContainer
                center={[defaultCenter.lat, defaultCenter.lng]}
                zoom={defaultZoom}
                style={{ width: "100%", height: "100%" }}
                scrollWheelZoom
            >
                {/* Tiles gratuitos do OpenStreetMap */}
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                />
                {children}
            </MapContainer>
        </Wrapper>
    );
};

export default LeafletMap;
